<template>
  <div class="cate">
    <div class="cate-parent flex flex-row flex-wrap pointer">
      <div
        v-for="(item, index) in parentItem"
        :key="index"
        class="cate-item parent"
        :class="{
          active: item.fieldCategoryId === currentParent.fieldCategoryId,
        }"
        @click="pItemClick(item)"
      >
        {{ item.fieldCategoryName }}
      </div>
    </div>
    <div class="cate-child flex flex-row flex-wrap pointer">
      <div
        v-for="(item, index) in childItem"
        :key="index"
        class="cate-item child"
        :class="{
          active: item.fieldCategoryId === currentChild.fieldCategoryId,
        }"
        @click="cItemClick(item)"
      >
        {{ item.fieldCategoryName }}
      </div>
    </div>
  </div>
</template>
<script>
import { expertCate } from "@/api/expert";
export default {
  data() {
    return {
      parentItem: [],
      childItem: [],
      currentParent: {},
      currentChild: {},
    };
  },
  created() {
    this.getType();
  },
  methods: {
    async getType(fieldCategoryPid) {
      const params = {};
      if (fieldCategoryPid) {
        params.fieldCategoryPid = fieldCategoryPid;
      }
      const data = await this.$axios.post(expertCate, params);
      this.parentItem = data;
      const { pId, cId } = this.$route.query;
      if (pId) {
        const pIndex = data.findIndex((item) => item.fieldCategoryId === +pId);
        if (cId) {
          const parent = data[pIndex];
          this.currentParent = parent;
          this.childItem = parent.children;
          const cIndex = data[pIndex].children.findIndex(
            (item) => item.fieldCategoryId === +cId
          );
          this.currentChild = data[pIndex].children[cIndex];
          this.getList();
        } else {
          this.pItemClick(data[pIndex]);
        }
      } else {
        this.pItemClick(data[0]);
      }
    },
    // 父类点击
    pItemClick(item) {
      this.currentParent = item;
      this.currentChild = {};
      this.childItem = item.children;
      this.getList();
    },
    // 子类点击
    cItemClick(item) {
      this.currentChild = item;
      this.getList();
    },
    // 获取列表数据
    async getList() {
      this.$emit("typeClick", {
        firstTypeId: this.currentParent.fieldCategoryId,
        secondTypeId: this.currentChild.fieldCategoryId,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.cate {
  background: white;
  padding: 15px 15px 5px 15px;
  &-item {
    margin-right: 20px;
    margin-bottom: 10px;
    // font-size: 12px;
    &:hover,
    &.active {
      color: $theme-color;
    }
    &.parent {
      font-size: 15px;
      font-weight: bold;
    }
    &.child {
      border: 1px solid white;
      padding: 3px 10px;
    }
    &.child.active {
      border: 1px solid $theme-color;
      border-radius: 15px;
    }
  }
  &-parent {
    margin-bottom: 5px;
    padding-left: 10px;
  }
}
</style>
